module.exports = __webpack_public_path__ + "img/checkbold_icon.0cf8e1d2.svg";